import { useEffect } from "react";
import siteConfig from "../config/siteConfig";

function PageMeta({ title, description, noIndex = false }) {
  useEffect(() => {
    const pageTitle = title
      ? `${title} | ${siteConfig.brandName}`
      : `${siteConfig.brandName} | Italian pantry, thoughtfully sourced`;

    document.title = pageTitle;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description || siteConfig.description;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${window.location.origin}${window.location.pathname}`;

    const socialTags = [
      ["property", "og:title", pageTitle],
      ["property", "og:description", meta.content],
      ["property", "og:url", canonical.href],
    ];

    socialTags.forEach(([attribute, value, content]) => {
      let tag = document.head.querySelector(`meta[${attribute}="${value}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attribute, value);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });

    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = noIndex ? "noindex, nofollow" : "index, follow";
  }, [description, noIndex, title]);

  return null;
}

export default PageMeta;
